/**
 * Form navigation generator: emits a per-form nav extract under admin/data/navigation/
 */

import type { FormSchema, GeneratedFile, GeneratorOptions } from '@core-engine/schema/types.js'
import { createGeneratedFile } from '@core-engine/utils/generated-files.js'
import { toCamelCase, toKebabCase } from '@core-engine/utils/string.js'

export interface FormNavigationResult {
  files: GeneratedFile[]
}

export function updateFormNavigation(
  schema: FormSchema,
  navigationDir: string,
  options: GeneratorOptions = {}
): FormNavigationResult {
  const adminRoutePath = options.adminRoutePath ?? '/admin'
  const icon = schema.icon || 'Inbox'
  const group = schema.navGroup?.label ?? 'Forms'
  const groupIcon = schema.navGroup?.icon ?? 'Inbox'
  const kebabName = toKebabCase(schema.name)
  const lines = [
    `    label: '${schema.label}'`,
    `    href: '${adminRoutePath}/forms/${kebabName}'`,
    `    icon: ${icon}`,
    `    group: '${group}'`,
    `    groupIcon: ${groupIcon}`
  ]

  if (schema.navGroup?.position != null) {
    lines.push(`    groupPosition: ${schema.navGroup.position}`)
  }

  if (schema.navPosition != null) {
    lines.push(`    position: ${schema.navPosition}`)
  }

  const content = `import type { AdminNavigationItem } from '@admin/types/navigation'
import { ${Array.from(new Set([icon, groupIcon]))
    .sort()
    .join(', ')} } from 'lucide-react'

export const ${toCamelCase(schema.name)}Nav: AdminNavigationItem[] = [
  {
${lines.join(',\n')}
  }
]
`

  return {
    files: [createGeneratedFile(`${navigationDir}/${schema.name}.ts`, content)]
  }
}
